import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { ThemeContext } from '../hooks/ThemeContext';

const PaymentCancel = () => {
  const { theme } = useContext(ThemeContext);
  const navigate = useNavigate();
  const isDark = theme === 'dark';

  return (
    <div className={`min-h-screen ${isDark ? 'bg-[#0f1114] text-white' : 'bg-slate-50 text-gray-800'}`}>
      <div className="container mx-auto px-4 py-12 max-w-3xl">
        <div className={`text-center p-8 rounded-lg ${isDark ? 'bg-[#1a1d24]' : 'bg-white'}`}>
          {/* Icône d'annulation */}
          <div className="w-20 h-20 mx-auto mb-6 bg-yellow-500/10 rounded-full flex items-center justify-center">
            <svg className="w-12 h-12 text-yellow-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
          </div>

          <h1 className="text-3xl font-bold mb-4">Paiement annulé</h1>
          <p className="text-lg mb-8 opacity-75">
            Votre paiement a été annulé. Aucun montant n'a été débité.
          </p>

          <div className="flex gap-4 justify-center">
            <button
              onClick={() => navigate('/cart')}
              className="px-6 py-3 bg-rose-500 hover:bg-rose-600 text-white font-semibold rounded-lg transition-colors"
            >
              Retour au panier
            </button>
            <button
              onClick={() => navigate('/')}
              className={`px-6 py-3 border rounded-lg font-medium transition-colors ${isDark ? 'border-white/10 hover:bg-white/5' : 'border-gray-200 hover:bg-gray-50'}`}
            >
              Continuer mes achats
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancel;
